import { apiGet, apiPost, apiPut, apiDelete } from "../api/http";
import {
    Activity,
    ActivityCategory,
    Technology,
    Employee,
    CreateActivityDto,
    UpdateActivityDto,
    PaginatedResponse,
    ActivityFilters,
} from "../types";

export const activityService = {

    // 🔵 Get all activities
    getActivities: async (
        filters: ActivityFilters
    ): Promise<PaginatedResponse<Activity>> => {

        const params = new URLSearchParams();

        if (filters.categoryId) params.append("categoryId", filters.categoryId.toString());
        if (filters.technologyId) params.append("technologyId", filters.technologyId.toString());
        if (filters.status) params.append("status", filters.status);
        if (filters.searchTerm) params.append("searchTerm", filters.searchTerm);

        params.append("PageNumber", filters.pageNumber.toString());
        params.append("PageSize", filters.pageSize.toString());

        return await apiGet<PaginatedResponse<Activity>>(`/Activity?${params.toString()}`);
    },

    // 🔵 Get by ID
    getActivityById: async (id: number): Promise<Activity> => {
    if (!id || isNaN(id)) {
        throw new Error("Invalid activity id");
    }
    return await apiGet<Activity>(`/Activity/${id}`);
},

    // 🔵 Create
    createActivity: async (activity: CreateActivityDto): Promise<Activity> => {
        return await apiPost<Activity>("/Activity", activity);
    },

    // 🔵 Update
    updateActivity: async (
        id: number,
        activity: UpdateActivityDto
    ): Promise<Activity> => {
        return await apiPut<Activity>(`/Activity/${id}`, activity);
    },

    // 🔵 Delete
    deleteActivity: async (id: number): Promise<void> => {
        await apiDelete(`/Activity/${id}`);
    },

    // 🔵 Categories
    getCategories: async (): Promise<ActivityCategory[]> => {
        const data = await apiGet<any[]>("/activity-categories");

        return (data || []).map((cat: any) => ({
            id: cat.categoryId,
            name: cat.categoryName,
            status: cat.status,
            createdBy: cat.createdBy,
            createdDate: cat.createdDate,
            updatedBy: cat.modifiedBy,
            updatedDate: cat.modifiedDate,
        }));
    },

    // 🔵 Technologies
    getTechnologies: async (): Promise<Technology[]> => {
        const data = await apiGet<any[]>("/technology-details");

        return (data || []).map((tech: any) => ({
            id: tech.techGroupId,
            name: tech.technologyName,
            status: tech.status ?? 'Active',
            createdBy: tech.createdBy,
            createdDate: tech.createdDate,
            updatedBy: tech.modifiedBy,
            updatedDate: tech.modifiedDate,
        }));
    },

    // 🔵 Employees
    getEmployees: async (): Promise<Employee[]> => {
        const data = await apiGet<any[]>("/winengage-emp/emp-details");

        return (data || []).map((emp: any) => ({
            id: emp.empCode,
            name: emp.empName,
            email: emp.emailId,
            displayName: emp.displayName
        }));
    },
};